const entryVideo = (selector: string) => {
	const container = document.querySelector(selector);
	if (!container) return;
	const video = container.querySelector('video');
	if (!video) return;
	const sources = video.querySelectorAll('source');
	const viableSources = new Array<{element: HTMLSourceElement, width: number, height: number}>();

	// get smaller of the two window or container
	const containerWidth = Math.min(window.innerWidth, container.getBoundingClientRect().width);
	const containerHeight = Math.min(window.innerHeight, container.getBoundingClientRect().height);

	// ascertain viable sources
	for (let i = 0, l = sources.length; i < l; ++i) {
		const width = parseInt(sources[i].dataset.width);
		const height = parseInt(sources[i].dataset.height);

		if (width > containerWidth && height > containerHeight) {
			viableSources.push({
				element: sources[i],
				width: width,
				height: height,
			});
		}
	}
	// Sort ascending
	viableSources.sort((a: any, b: any) => a.width - b.width);

	if (viableSources.length > 0) {
		const element = viableSources[0].element;
		video.src = element.dataset.src;
		video.play();
	} 
	// TODO: get rid of this if possible. Or refactor.
	else {
		const element = sources[0];
		video.src = element.dataset.src;
		video.play();
	}
}
export default entryVideo;
